import { mapGetters } from 'vuex';
import { buildBasketHash, hasVisibleDiscount } from '@/helpers';

export default {
  computed: {
    ...mapGetters({
      basket: 'basket/basket',
      saleRows: 'sales/saleRows',
      salePromo: 'sales/salePromo',
      saleBasketHash: 'sales/saleBasketHash',
      isSalesLoading: 'sales/isSalesLoading'
    }),
    promo() {
      return this.isSaleStale ? null : this.salePromo;
    },
    isSaleStale() {
      return this.isSalesLoading || this.saleBasketHash !== buildBasketHash(this.basket);
    },
    promoDiscount() {
      const discount = this.promo ? this.promo.discount : this.rowsSaleDiscount;

      return discount > 0 ? discount : 0;
    },
    rowsSaleDiscount() {
      return (this.basket || []).reduce((sum, product) => {
        const row = this.freshRow(product);
        if (!row || row.oldSum === null) return sum;

        return sum + (row.oldSum - row.sum);
      }, 0);
    },
    cartTotal() {
      return (this.basket || []).reduce((sum, product) => sum + this.rowSum(product), 0);
    },
    cartOldTotal() {
      return (this.basket || []).reduce((sum, product) => sum + this.rowRegularSum(product), 0);
    }
  },
  methods: {
    saleRow(product) {
      if (!product || !product.select_type) return null;

      return (this.saleRows && this.saleRows[product.select_type.id]) || null;
    },
    isRowFresh(product) {
      const row = this.saleRow(product);

      return !!row && row.count === product.select_count;
    },
    freshRow(product) {
      return this.isRowFresh(product) ? this.saleRow(product) : null;
    },
    localPrice(product) {
      return (product && product.select_type && product.select_type.price) || 0;
    },
    localOldPrice(product) {
      const priceRow = product && product.select_type;
      if (!priceRow || !priceRow.oldPrice || !(priceRow.oldPrice > priceRow.price)) return null;

      return priceRow.oldPrice;
    },
    rowSum(product) {
      const row = this.freshRow(product);
      if (row) return row.sum;

      return this.localPrice(product) * (product.select_count || 0);
    },
    rowUnitPrice(product) {
      const row = this.freshRow(product);
      if (row) return row.unitPrice;

      return this.localPrice(product);
    },
    rowOldSum(product) {
      const row = this.freshRow(product);
      if (row) {
        if (row.oldSum !== null && row.oldSum > row.sum) return row.oldSum;

        return hasVisibleDiscount(row) ? row.oldPrice * row.count : null;
      }

      const oldPrice = this.localOldPrice(product);
      if (oldPrice === null) return null;

      return oldPrice * product.select_count;
    },
    rowRegularSum(product) {
      const row = this.freshRow(product);
      if (row) {
        if (row.oldSum !== null) return row.oldSum;

        return hasVisibleDiscount(row) ? row.oldPrice * row.count : row.sum;
      }

      const oldPrice = this.localOldPrice(product);
      if (oldPrice === null) return this.rowSum(product);

      return oldPrice * product.select_count;
    },
    rowOldUnitPrice(product) {
      const row = this.freshRow(product);
      if (row) return hasVisibleDiscount(row) ? row.oldPrice : null;

      return this.localOldPrice(product);
    }
  }
};
